import React from 'lib/react';
import { EVGrid, EVButton, makeStyles } from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useDispatch, useSelector } from 'lib/redux';
import clsx from 'lib/clsx';
import NewBadge from 'commonComponents/newBadge';
import { setPanelType, propertyDataRequest } from '../Order.actions';
import { formatAddress } from '../Order.utils';
import { PANEL_TYPES } from '../Order.constants';

const useStyles = makeStyles(() => ({
  prePanelContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    gap: '24px',
    height: '100%',
    justifyContent: 'center',
    flex: 1,
  },
  propertyDataButton: {
    '& >span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
    },
  },
  optionButton: {
    boxSizing: 'content-box',
    minHeight: '35px',
  },
}));

function PrePanel() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { geocodedAddress } = useSelector(({ orderAddresses }) => ({
    geocodedAddress: orderAddresses.geocodedAddress,
  }));

  const handlePropertyDataClick = () => {
    if (geocodedAddress) {
      const completeAddress = formatAddress(geocodedAddress);
      dispatch(setPanelType(PANEL_TYPES.PROPERTY_DATA));
      dispatch(propertyDataRequest(completeAddress));
    }
  };

  const handleStructureMeasurementsClick = () => {
    dispatch(setPanelType(PANEL_TYPES.STRUCTURE_MEASUREMENTS));
  };

  return (
    <EVGrid className={classes.prePanelContainer}>
      <EVButton
        variant="contained"
        color="primary"
        onClick={handlePropertyDataClick}
        className={clsx(classes.propertyDataButton, classes.optionButton)}
      >
        {t('order_property_data_title', 'Property Data')}
        <NewBadge label="Beta" />
      </EVButton>

      <EVButton
        variant="contained"
        color="primary"
        onClick={handleStructureMeasurementsClick}
        className={classes.optionButton}
      >
        {t('order_structure_measurements_title', 'Structure Measurements')}
      </EVButton>
    </EVGrid>
  );
}

export default PrePanel;
